import React from "react";
import { FilterTabsProps } from "../../types/messages.types";
import { UI_TEXT } from "../../constants/messages.constants";

/**
 * FilterTabs Component
 * All/Unread filter buttons
 */
const FilterTabs: React.FC<FilterTabsProps> = ({
  activeFilter,
  onFilterChange,
}) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={() => onFilterChange("all")}
        className={`flex-1 px-4 py-2.5 rounded-xl font-medium text-sm transition-all ${
          activeFilter === "all"
            ? "bg-[#F56948] text-white shadow-md"
            : "bg-neutral-100 text-neutral-700 hover:bg-neutral-200 dark:bg-neutral-700 dark:text-neutral-200 dark:hover:bg-neutral-600"
        }`}
      >
        {UI_TEXT.FILTERS.ALL}
      </button>
      <button
        onClick={() => onFilterChange("unread")}
        className={`flex-1 px-4 py-2.5 rounded-xl font-medium text-sm transition-all ${
          activeFilter === "unread"
            ? "bg-[#F56948] text-white shadow-md"
            : "bg-neutral-100 text-neutral-700 hover:bg-neutral-200 dark:bg-neutral-700 dark:text-neutral-200 dark:hover:bg-neutral-600"
        }`}
      >
        {UI_TEXT.FILTERS.UNREAD}
      </button>
    </div>
  );
};

export default FilterTabs;
